<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T14:45:54+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe Show Case, for example visit www.lorinthe.com/refcase/2
@Last modified by:   tom
@Last modified time: 2017-12-20T15:02:07+01:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Depends very much on structure of language object:

cases:
  label: 'cases'
  title: 'case studies'
  payload: 'We developed & contributed to <b>hundreds</b> of applications. To list a few:'
  1:
    label: 'qerspi'
    title: 'Qrespi'
    img: 'qrespi-coach.jpg'
    header: 'Connect to Care'
    intro: 'Qrespi is an on-line application that let you remotely support seniors with Internet browsing.'
    chapter:
      1:
        title: 'Example'
        payload: 'For example, you can use Qrespi to support grandparents with on-line shopping. For a smooth experience,  seniors use a special designed desk stand that holds a tablet. The tablet has only one screen showing video calling and a remote browser.'
        img: '/static/img/cases/qrespi.jpg'
        embed:
          src: '/static/img/cases/qrespi-framework-v03.svg'
          caption: 'Click on this frame to step through the slides<br/><br/>you can also use &larr; &rarr; buttons.<br/>press "i" to see an overview.'
        quote: 'we say good !'
// maximal 6 chapters
-->

<template lang="html">
  <c-page id="refcase"
        :title="$t('cases.' + refid + '.title')"
        :jbheader="$t('cases.' + refid + '.header')"
        :jblead="$t('cases.' + refid + '.intro')"
        jbcolor="secondary"
        :sideimage="assetUrl('img/cases/' + $t('cases.' + refid + '.img'))"
        imgmodal
  >
    <!-- chapters -->
    <div
      v-for="i in 6"
      :key="i"
    >
      <div v-if="$te('cases.' + refid + '.chapter.' + i, 'en')">
        <h2 class="text-secondary">
          {{ $t('cases.' + refid + '.chapter.' + i + '.title') }}
        </h2>
        <p v-html="$t('cases.' + refid + '.chapter.' + i + '.payload')" />
        <lzimg
          v-if="$te('cases.' + refid + '.chapter.' + i + '.img','en')"
          :src="assetUrl('img/cases/'+ $t('cases.' + refid + '.chapter.' + i + '.img'))"
          fluid
          width="825"
          height="412"
          class="subimg"
        />
        <embpage
          v-if="$te('cases.' + refid + '.chapter.' + i + '.embed', 'en')"
          :src="assetUrl($t('cases.' + refid + '.chapter.' + i + '.embed.src'))"
          :caption="$t('cases.' + refid + '.chapter.' + i + '.embed.caption')"
        />
        <blockquote
          v-if="$te('cases.' + refid + '.chapter.' + i + '.quote','en')"
          v-html="$t('cases.' + refid + '.chapter.' + i + '.quote')"
        />
      </div>
    </div> <!-- end chapter -->
  </c-page>
</template>

<script>
export default {
  computed: {
    refid: function () {
      return this.$route.params.id
    }
  }
}
</script>

<style lang="scss" scoped >
</style>
